import { Box, Typography } from '@mui/material'
import React from 'react'
import styles from '../styles/usersTfe.module.scss'
import { TableComponent } from 'shared/components/Table.component'
import { columns } from 'shared/utils'
import { UseFormAddUsersTfe } from '../hook/UseFormAddUsersTfe'
import { useWidth } from 'shared/hooks/HookDetailedConsultation/useWidth'
import { SearchItems } from 'shared/components/paginator/SearchItems'

export const AddUsersTfe = () => {

  const { rowSelected, columns, content, handleChangeCheck } = UseFormAddUsersTfe();

  const { width } = useWidth();

  return (
        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} marginTop={'1rem'} className={styles.containerAddUsers}>
            <Typography className={styles.title}>Seleccionar usuarios para agregar a TFE</Typography>
            <span className={`${styles.searchItems}`} data-testid='search-items'>
              <SearchItems data={content!} placeholder='Buscar' autocomplete={false} />
            </span>
            <TableComponent 
              columns={columns}
              title=''
              classTotalElemnt={width < 500 ? '' : 'classTotalElemnt'}
              showBtnCollapse={true}
              isSearch={true}
              rowSelected={rowSelected}
              rowHeader={false}
              widthSearchFull={true}
              selectRow={handleChangeCheck}
              selectAllRows={handleChangeCheck}
            />
        </Box>
  )
}
